import React from 'react'

export default function DFTag({ label, color }) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '2px 8px',
        borderRadius: 99,
        fontSize: 11,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        background: color ? `${color}18` : 'var(--df-surface-2)',
        color: color || 'var(--df-ink-3)',
        border: color ? `1px solid ${color}30` : '1px solid transparent',
      }}
    >
      {label}
    </span>
  )
}
